var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "drawer-info__head",
      attrs: { "data-ui-section": "drawer-head" }
    },
    [
      _c("VsButton", {
        staticClass:
          "\n      drawer-info__head drawer-info__head--type\n      p-0 text-white\n    ",
        attrs: { icon: "md:minimize" },
        on: { click: _vm.toggleSidePanel }
      }),
      _vm._v(" "),
      _vm.publicUrl
        ? _c(
            "VsButton",
            {
              staticClass:
                "drawer-info__head drawer-info__head--type p-0 text-white",
              attrs: {
                icon: "md:playlist_play",
                href: _vm.publicUrl,
                tracker: _vm.getAnalyticPayload(function(e) {
                  return e.player["video-drawer"].click["drawer-link"]
                }, _vm.publicUrl)
              }
            },
            [
              _vm.publicUrl ? _c("span", [_vm._v("Open")]) : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm._f("toFriendlyType")(_vm.type)))])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.author
        ? _c(
            "VsButton",
            {
              staticClass:
                "drawer-info__head drawer-info__head--author p-0 text-white",
              attrs: {
                href: _vm.author.publicUrl,
                tracker: _vm.getAnalyticPayload(function(e) {
                  return e.player["video-drawer"].click["author-link"]
                }, _vm.author),
                icon: "md:account_circle"
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.author.displayName) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }